import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import assetUrl from '../api/assetUrl';
import { toFormData } from '../api/formData';
import MultilingualField from '../components/MultilingualField';
import { useNotify, errorMessage } from '../components/Toast';
import { IconEdit, IconTrash } from '../components/Icons';
import '../components/AdminUI.css';

export default function HeroSlides() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const notify = useNotify();

  const load = () => axios.get('/hero-slides').then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      // PHP doesn't parse multipart/form-data on PUT — use Laravel _method spoofing.
      const payload = editing.id ? { ...editing, _method: 'PUT' } : editing;
      const fd = toFormData(payload);
      const url = editing.id ? `/hero-slides/${editing.id}` : '/hero-slides';
      await axios.post(url, fd);
      notify.success(editing.id ? 'Slide mise à jour' : 'Slide créée');
      setEditing(null);
      load();
    } catch (err) {
      notify.error(errorMessage(err, "Erreur lors de l'enregistrement de la slide"));
    }
  };
  const remove = async (id) => { if (window.confirm('Supprimer ?')) { await axios.delete(`/hero-slides/${id}`); load(); } };

  return (
    <div className="admin-page">
      {!editing && (
        <div className="admin-toolbar" style={{ justifyContent: 'flex-end' }}>
          <button className="admin-btn admin-btn-gold" onClick={() => setEditing({ image_path: '', cta_url: '', cta_secondary_url: '', i18n: {}, is_active: true, sort_order: 0 })}>
            + Nouvelle slide
          </button>
        </div>
      )}

      {editing && (
        <div className="admin-form-card">
          <div className="admin-form-header">
            <h3>{editing.id ? 'Modifier la slide' : 'Nouvelle slide'}</h3>
          </div>
          <div className="admin-form-body">
            <div className="admin-form-section">
              <div className="admin-form-section-title">Image</div>
              <input type="file" accept="image/*" onChange={(e) => setEditing({ ...editing, image: e.target.files?.[0] })} />
              {editing.image_path && <img src={assetUrl(editing.image_path)} alt="" style={{ height: 100, marginTop: 4, borderRadius: 4, border: '1px solid #e5e7eb' }} />}
            </div>
            <div className="admin-form-section">
              <div className="admin-form-section-title">Liens & ordre</div>
              <div className="admin-grid admin-grid-2">
                <div><label className="admin-label">CTA principal — URL</label><input className="admin-input" value={editing.cta_url || ''} onChange={(e) => setEditing({ ...editing, cta_url: e.target.value })} /></div>
                <div><label className="admin-label">CTA secondaire — URL</label><input className="admin-input" value={editing.cta_secondary_url || ''} onChange={(e) => setEditing({ ...editing, cta_secondary_url: e.target.value })} /></div>
                <div><label className="admin-label">Ordre</label><input className="admin-input" type="number" value={editing.sort_order || 0} onChange={(e) => setEditing({ ...editing, sort_order: parseInt(e.target.value || 0) })} /></div>
                <div>
                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 13.5, color: '#475569' }}>
                    <input type="checkbox" checked={!!editing.is_active} onChange={(e) => setEditing({ ...editing, is_active: e.target.checked })} /> Actif
                  </label>
                </div>
              </div>
            </div>
            <MultilingualField label="Textes" value={editing.i18n} fields={['title', 'subtitle', 'cta_label', 'cta_secondary_label']} onChange={(v) => setEditing({ ...editing, i18n: v })} />
          </div>
          <div className="admin-form-actions">
            <button className="admin-btn admin-btn-outline" onClick={() => setEditing(null)}>Annuler</button>
            <button className="admin-btn admin-btn-gold" onClick={save}>Enregistrer</button>
          </div>
        </div>
      )}

      <div className="admin-grid admin-grid-3">
        {items.map((s) => (
          <div key={s.id} className="admin-card" style={{ padding: 12 }}>
            {s.image_path && <img src={assetUrl(s.image_path)} alt="" style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 4 }} />}
            <div style={{ marginTop: 8, fontWeight: 600 }}>{s.i18n?.fr?.title || '(sans titre)'}</div>
            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
              <span className={`status-badge ${s.is_active ? 'active' : 'inactive'}`}>{s.is_active ? 'Actif' : 'Inactif'}</span>
              <span style={{ marginLeft: 8 }}>Ordre {s.sort_order}</span>
            </div>
            <div className="admin-actions" style={{ marginTop: 10 }}>
              <button className="admin-icon-btn" title="Modifier" aria-label="Modifier" onClick={() => setEditing(s)}>
                <IconEdit />
              </button>
              <button className="admin-icon-btn is-danger" title="Supprimer" aria-label="Supprimer" onClick={() => remove(s.id)}>
                <IconTrash />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
